// Путь: D:\QR\QR-WEB\dashboard\src\components\Auth\Register.js
// Версия: 2.2.0 - Enhanced Left Block
// Дата: 03.12.2025

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

export const Register = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState('user');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== passwordConfirm) {
      setError('Пароли не совпадают');
      return;
    }

    if (password.length < 6) {
      setError('Пароль минимум 6 символов');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          password: password,
          role: role
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || data.error || 'Ошибка регистрации');
      }

      localStorage.setItem('pendingEmail', email.trim().toLowerCase());
      navigate('/verify-email', { state: { email: email.trim().toLowerCase() } });

    } catch (err) {
      setError(err.message || 'Ошибка регистрации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Левая часть - информация */}
      <div className="auth-info">
        <div className="auth-info-content">
          <div className="brand">
            <span className="brand-icon">🎁</span>
            <h1 className="brand-name">DARY</h1>
            <p className="brand-tagline">Digital Asset Reward Yours</p>
          </div>
          
          <div className="features">
            <h2 className="features-title">Присоединяйтесь к DARY</h2>
            <p className="features-desc">
              Создайте аккаунт и начните отправлять криптовалюту как подарки
            </p>
            
            <ul className="features-list">
              <li>
                <span className="feature-icon">🆓</span>
                <div>
                  <strong>Бесплатная регистрация</strong>
                  <span>Без скрытых платежей и комиссий</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">🚀</span>
                <div>
                  <strong>Быстрый старт</strong>
                  <span>Начните за 2 минуты</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">🔐</span>
                <div>
                  <strong>Безопасность</strong>
                  <span>Ваши данные под защитой</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">🌍</span>
                <div>
                  <strong>Без границ</strong>
                  <span>Отправляйте подарки по всему миру</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Правая часть - форма */}
      <div className="auth-form-section">
        <div className="auth-card">
          <div className="auth-card-header">
            <h2>Создать аккаунт</h2>
            <p>Выберите тип аккаунта и заполните данные</p>
          </div>

          {/* Role Selector */}
          <div className="role-selector">
            <button
              type="button"
              className={`role-btn ${role === 'user' ? 'active' : ''}`}
              onClick={() => setRole('user')}
            >
              <span className="role-icon">👤</span>
              <span className="role-name">Личный</span>
              <span className="role-desc">Отправляйте подарки друзьям</span>
            </button>
            <button
              type="button"
              className={`role-btn role-btn--business ${role === 'business' ? 'active' : ''}`}
              onClick={() => setRole('business')}
            >
              <span className="role-icon">🏢</span>
              <span className="role-name">Бизнес</span>
              <span className="role-desc">Массовые подарки, аналитика</span>
            </button>
          </div>
          
          {error && <div className="auth-error">{error}</div>}
          
          <form onSubmit={handleRegister} className="auth-form">
            <div className="form-group">
              <label>Email</label>
              <div className="input-wrapper">
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  disabled={loading}
                />
              </div>
            </div>
            
            <div className="form-group">
              <label>Пароль</label>
              <div className="input-wrapper">
                <span className="input-icon">🔑</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Минимум 6 символов"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Подтвердите пароль</label>
              <div className="input-wrapper">
                <span className="input-icon">🔑</span>
                <input
                  type="password"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  placeholder="Повторите пароль"
                  required
                  disabled={loading}
                />
              </div>
            </div>
            
            <button type="submit" disabled={loading} className={`btn-submit ${role === 'business' ? 'btn-submit--business' : ''}`}>
              {loading ? '⏳ Регистрация...' : role === 'business' ? '🏢 Создать бизнес-аккаунт' : '🚀 Создать аккаунт'}
            </button>
          </form>
          
          <div className="auth-divider">
            <span>или</span>
          </div>

          <Link to="/login" className="btn-register">
            ← Уже есть аккаунт? Войти
          </Link>
          
          <p className="auth-footer">
            Регистрируясь, вы соглашаетесь с <a href="/terms">условиями</a> и <a href="/privacy">политикой конфиденциальности</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;